import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { authenticationLocales } from '@loggi/authentication';
import { componentsLocales } from '@loggi/components';

i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': {
      ...authenticationLocales.ptBr,
      ...componentsLocales['pt-BR']
    }
  },
  lng: 'pt-BR',
  fallbackLng: 'pt-BR'
});

export default i18n;
